module.exports = __webpack_public_path__ + "static/media/lk.c850d42d.svg";